import { Amplify } from "aws-amplify";

const redirectBase = process.env.REACT_APP_REDIRECT_BASE || "http://localhost:3001";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [`${redirectBase}/`],
          redirectSignOut: [`${redirectBase}/`],
          responseType: "code",
        },
      },
    },
  },
});
